import { render } from "./loginPopup.vue?vue&type=template&id=07620d83"
import script from "./loginPopup.vue?vue&type=script&lang=js"
export * from "./loginPopup.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__